import { createFileRoute } from '@tanstack/react-router'

import {Authorisation} from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import {PERMISSIONS} from "@/lib/auth/roles";
import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import VerifiedByAdviser from "@/modules/verified-by-adviser";
import {contentAddedOrSharedStatsQueryOptions, verifiedByAdviserStatsQueryOptions} from "@/modules/verified-by-adviser/hooks";
import {
  defaultFetchParamsVerifiedByAdviser,
  mergedVerifiedAdviserScoresSearchSchema,
  VerifiedAdviserScoresSearch
} from "@/types/route-search-schemas";
import {DataLoader} from "@/types/router-context";
import {VERIFIED_ADVISER_SCORES_PATH, VERIFIED_ADVISER_SCORES_URL} from "@/utils/urls";

export const Route = createFileRoute(VERIFIED_ADVISER_SCORES_PATH)({
  component: VerifiedAdviserScores,
  validateSearch: (search: Record<string, unknown>): VerifiedAdviserScoresSearch => validateSearchWithDefaults(mergedVerifiedAdviserScoresSearchSchema, search),
  loader: ({ context: { queryClient, date, identity } }: DataLoader) => {
    if (isCurrentPage(VERIFIED_ADVISER_SCORES_URL)) {
      return
    }
    if (identity?.showVerifiedStatistics) {
      queryClient.prefetchQuery(verifiedByAdviserStatsQueryOptions(date, defaultFetchParamsVerifiedByAdviser))
      queryClient.prefetchQuery(contentAddedOrSharedStatsQueryOptions(date, defaultFetchParamsVerifiedByAdviser))
    }
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Home', path: '/' },
        { label: 'Verified statistics by adviser', path: '/verified-adviser-scores' },
      ]
    }
  }
})

function VerifiedAdviserScores() {
  return(
    <div className={'flex flex-col items-center justify-center'}>
      <Authorisation roles={[]} permissions={[PERMISSIONS.SHOW_VERIFIED_STATISTICS]} forbiddenFallback={<Unauthorized />}>
        <VerifiedByAdviser />
      </Authorisation>
    </div>
  )
}
